import * as React from 'react';
import { Grid, Typography, Link, IconButton, Card, CardContent, FormControl, InputLabel, Input, Button } from '@material-ui/core';
import { addReviewQuestionComment } from 'src/effects/utils/preview';
import HelpIcon from '@material-ui/icons/Help';
import WarningIcon from '@material-ui/icons/Warning';
import * as moment from 'moment';
import { addReviewComment, getAllReviewQuestionsComments } from 'src/effects/api/api.module';
import ReactHtmlParser from 'react-html-parser';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { getRamIntegrationDataCall } from 'src/effects/api/api.module';
import { QuestionStatus, AdminQuestionStatus } from '../../constants/Enum/ModuleEnum';
import InputTypeQuestionComponent from '../responses/QuestionTypes/InputTypeQuestionComponent';
import NumericTypeQuestionComponent from '../responses/QuestionTypes/NumericTypeQuestionComponent';
import DatepickerTypeQuestionComponent from '../responses/QuestionTypes/DatepickerTypeQuestionComponent';
import DropdownTypeQuestionComponent from '../responses/QuestionTypes/DropdownTypeQuestionComponent';
import RamIntegrationComponent from '../responses/RamIntegrationComponent';
import RadioTypeQuestionComponent from '../responses/QuestionTypes/RadioTypeQuestionComponent';
import CheckboxTypeQuestionComponent from '../responses/QuestionTypes/CheckboxTypeQuestionComponent';
import ConfirmationComponent from 'src/components/common//notification/ConfirmationComponent';
import { APPROVED_QUESTION_CONFIRAMATION, ASSIGN_CREATOR_QUESTION_CONFIRAMATION, REJECT_QUESTION_CONFIRAMATION } from 'src/constants/NotificationMessageConstant';
import ReviewCommentComponent from './ReviewCommentComponent';

export default class QuestionReviewComponent extends React.Component<any, any> {
    state = {
        validationMessages: [],
        collapsed: true,
        showCommentsDialog: false,
        addCommentDivVisible: false,
        addCommentDescription: '',
        showRamIntegrationDialog: false,
        ramIntegrationData: [],
        adminQuestionStatus: AdminQuestionStatus.None,
        comments: []
    };

    constructor(props: any) {
        super(props);

        this.updateQuestion = this.updateQuestion.bind(this);
        this.toggleExpand = this.toggleExpand.bind(this);
        this.handleShowAllComments = this.handleShowAllComments.bind(this);
        this.handleShowAllCommentsClose = this.handleShowAllCommentsClose.bind(this);
        this.toggleAddCommentDiv = this.toggleAddCommentDiv.bind(this);
        this.handleCommentDescriptionChange = this.handleCommentDescriptionChange.bind(this);
        this.handleRamIntegrationClose = this.handleRamIntegrationClose.bind(this);
    }


    componentDidMount() {
        this.setState({
            ['showDataBox_' + this.props.pageNumber + '_' + this.props.clusterIndex + '_' + this.props.questionId]: false,
            ['showLastYearData_' + this.props.pageNumber + '_' + this.props.clusterIndex + '_' + this.props.questionId]: {}
        });
    }

    // add comments for review questions
    addReviewQuestionComment = (event: any) => {
        const data = {
            question_id: this.props.question.question_id,
            comment_text: this.state.addCommentDescription,
            question_status: this.props.question.status,
            module_id: this.props.moduleId,
            page_number: this.props.pageNumber
        };

        addReviewComment(data).then((response) => {
            if (response && response.data && response.data.success && response.data.payload) {
                const comment = {
                    comment_text: response.data.payload.comment_text,
                    commented_by_name: response.data.payload.commented_by_name,
                    commented_by_email: response.data.payload.commented_by_email,
                    commented_by_role: response.data.payload.commented_by_role,
                    commented_date: response.data.payload.commented_date,

                };

                this.setState({ addCommentDescription: '', addCommentDivVisible: false })
                addReviewQuestionComment(this.props, comment);
            }
        });
    }

    handleCommentDescriptionChange(event: any) {
        this.setState({ addCommentDescription: event.target.value });
    }

    toggleAddCommentDiv(addCommentDivVisible: any) {
        this.setState({ addCommentDivVisible, addCommentDescription: '' });
    }

    handleShowAllComments(questionId: any) {
        let comments: any = [];
        getAllReviewQuestionsComments({
            questionId
        }).then((res) => {
            if (res && res.data.success) {
                comments = res.data.payload;
            }

            this.setState({ showCommentsDialog: true, comments });
        });
    }

    handleShowAllCommentsClose(value: any) {
        this.setState({ showCommentsDialog: !value, comments: [] });
    }

    toggleExpand(collapsed: any, event: any) {
        this.setState({ collapsed });
    }

    handleRamIntegration(ramQuestionIndicatorCode: any, ctryModuleSurveyMappingId: any, event: any) {
        this.props.loaderVisibility(true);
        const data = {
            ramIntegrationQuestionIndicatorCode: ramQuestionIndicatorCode,
            countryModuleSurveyMappingId: ctryModuleSurveyMappingId
        };

        getRamIntegrationDataCall(data).then((res) => {
            if (res.data.success) {
                this.setState({ ramIntegrationData: res.data.payload });
                this.setState({ showRamIntegrationDialog: true });
            }
            this.props.loaderVisibility(false);
        })
            .catch((err) => {
                this.props.loaderVisibility(false);
            });
    }

    handleRamIntegrationClose(value: any) {
        this.setState({ showRamIntegrationDialog: !value });
    }

    updateQuestion(updateQuestionData: any) {
        return;

        this.props.updateQuestion(updateQuestionData);
    }

    renderQuestionByQuestionType() {
        switch (this.props.question.input_type) {
            case 1:
                return <InputTypeQuestionComponent isReviewQuetion={true} updateQuestion={this.updateQuestion} surveyStatus={this.props.surveyStatus} moduleId={this.props.moduleId} validationMessages={this.state.validationMessages} pages={this.props.pages} pageNumber={this.props.pageNumber} clusterIndex={this.props.clusterIndex} questionIndex={this.props.questionIndex} questionId={this.props.questionId} question={this.props.question} />
            case 2:
                return <NumericTypeQuestionComponent isReviewQuetion={true} updateQuestion={this.updateQuestion} surveyStatus={this.props.surveyStatus} moduleId={this.props.moduleId} pagePreview={this.props.pagePreview} pages={this.props.pages} pageNumber={this.props.pageNumber} clusterIndex={this.props.clusterIndex} questionIndex={this.props.questionIndex} questionId={this.props.questionId} question={this.props.question} />
            case 3:
                return <DatepickerTypeQuestionComponent isReviewQuetion={true} updateQuestion={this.updateQuestion} surveyStatus={this.props.surveyStatus} pages={this.props.pages} pageNumber={this.props.pageNumber} clusterIndex={this.props.clusterIndex} questionIndex={this.props.questionIndex} questionId={this.props.questionId} question={this.props.question} />
            case 4:
                return <DropdownTypeQuestionComponent isReviewQuetion={true} updateQuestion={this.updateQuestion} surveyStatus={this.props.surveyStatus} moduleId={this.props.moduleId} pages={this.props.pages} clusterIndex={this.props.clusterIndex} questionIndex={this.props.questionIndex} questionId={this.props.questionId} question={this.props.question} />
            case 5:
                return <RadioTypeQuestionComponent isReviewQuetion={true} updateQuestion={this.updateQuestion} surveyStatus={this.props.surveyStatus} pages={this.props.pages} pageNumber={this.props.pageNumber} clusterIndex={this.props.clusterIndex} questionIndex={this.props.questionIndex} questionId={this.props.questionId} question={this.props.question} />
            case 6:
                return <CheckboxTypeQuestionComponent isReviewQuetion={true} updateQuestion={this.updateQuestion} surveyStatus={this.props.surveyStatus} pages={this.props.pages} pageNumber={this.props.pageNumber} clusterIndex={this.props.clusterIndex} questionIndex={this.props.questionIndex} questionId={this.props.questionId} question={this.props.question} />
            default:
                return;
        }
    }

    getQuestionByQuestionId(questionId: any) {
        const questionMetadata = {
            clusterIndex: 0,
            questionIndex: 0,
            question: undefined,
            questionId: 0
        }

        for (const page of this.props.pages) {
            for (let clusterIndex: any = 0; clusterIndex < page.page.question_clusters.length; clusterIndex++) {
                for (let questionIndex: any = 0; questionIndex < page.page.question_clusters[clusterIndex].questions.length; questionIndex++) {
                    const questionData = page.page.question_clusters[clusterIndex].questions[questionIndex];
                    if (questionData && questionData.question_id === questionId) {
                        questionMetadata.clusterIndex = clusterIndex;
                        questionMetadata.questionIndex = questionIndex;
                        questionMetadata.questionId = questionId;
                        questionMetadata.question = questionData;
                        return questionMetadata;
                    }
                }
            }
        }

        return questionMetadata;
    }

    getQuestionResponses(question: any) {
        const setOneResponse = question.question_responses[0].value;
        let setTwoResponse;
        let setThreeResponse;

        if (question.class_type === 2) {
            setTwoResponse = question.question_responses[1].value;
        }
        if (question.class_type === 3) {
            setTwoResponse = question.question_responses[1].value;
            setThreeResponse = question.question_responses[2].value;
        }

        const response = {
            setOneResponse,
            setTwoResponse,
            setThreeResponse
        };

        return response;
    }

    validateQuestionConditions(newProps: any) {
        const validationMessages: any = [];
        const question = newProps.question;
        const response = this.getQuestionResponses(question);

        for (const validation of newProps.question.validations) {
            const validationMessage: any = this.validationConditionCheck(validation, newProps, question, response);
            console.log("Validation message", validationMessage)
            if (validationMessage) {
                validationMessages.push(validationMessage)
            }
        }

        if (newProps.question.input_type === 2 && newProps.question.limit && newProps.question.min_value && newProps.question.max_value) {
            const validationMessage = this.validateForLimitCheck(question, response);
            if (validationMessage) {
                validationMessages.push(validationMessage);
            }
        }

        this.setState({ validationMessages });
    }

    validationConditionCheck(validationCondition: any, newProps: any, question: any, response: any) {
        let validationMessage = '';

        if (question && question.question_id) {
            switch (validationCondition.operator) {
                case "=":
                    validationMessage = this.validateForEqualCheck(question, validationCondition, response);
                    break;

                case "!=":
                    validationMessage = this.validateForNotEqualCheck(question, validationCondition, response);
                    break;

                case ">":
                    validationMessage = this.validateForGreaterThanCheck(question, validationCondition, response);
                    break;

                case "<":
                    validationMessage = this.validateForLessThanCheck(question, validationCondition, response);
                    break;

                case ">=":
                    validationMessage = this.validateForGreaterThanEqualCheck(question, validationCondition, response);
                    break;

                case "<=":
                    validationMessage = this.validateForLessThanEqualCheck(question, validationCondition, response);
                    break;

                default:
                    validationMessage = '';
                    break;
            }

        }

        return validationMessage;
    }

    validateForLimitCheck(question: any, response: any) {
        const minVal = question.min_value;
        const maxVal = question.max_value;

        switch (question.class_type) {
            case 1: {
                if (!(parseInt(response.setOneResponse, 10) >= minVal && parseInt(response.setOneResponse, 10) <= maxVal)) {
                    return `Response must be between ${minVal} - ${maxVal}`;
                }
            }
                break;
            case 2: {
                if (!(parseInt(response.setOneResponse, 10) >= minVal && parseInt(response.setOneResponse, 10) <= maxVal)
                    || !(parseInt(response.setTwoResponse, 10) >= minVal && parseInt(response.setTwoResponse, 10) <= maxVal)) {
                    return `Response must be between ${minVal} - ${maxVal}`;
                }
            }
                break;
            case 3: {
                if (!(parseInt(response.setOneResponse, 10) >= minVal && parseInt(response.setOneResponse, 10) <= maxVal)
                    || !(parseInt(response.setTwoResponse, 10) >= minVal && parseInt(response.setTwoResponse, 10) <= maxVal)
                    || !(parseInt(response.setThreeResponse, 10) >= minVal && parseInt(response.setThreeResponse, 10) <= maxVal)) {
                    return `Response must be between ${minVal} - ${maxVal}`;
                }
                break;
            }
        }

        return '';
    }

    validateForEqualCheck(question: any, validationCondition: any, response: any) {
        const validationValue = validationCondition.value;
        switch (question.input_type) {
            case 1:
            case 4:
            case 5:
                {
                    switch (question.class_type) {
                        case 1: {
                            return response.setOneResponse === validationValue && response.setOneResponse ? validationCondition.message.en : '';
                        }
                            break;
                        case 2: {
                            return (response.setOneResponse === validationValue || response.setTwoResponse === validationValue) && response.setOneResponse && response.setTwoResponse
                                ? validationCondition.message.en : '';
                        }
                            break;
                        case 3: {
                            return (response.setOneResponse === validationValue || response.setTwoResponse === validationValue || response.setThreeResponse === validationValue) && response.setOneResponse && response.setTwoResponse && response.setThreeResponse
                                ? validationCondition.message.en : '';
                        }
                            break;
                    }
                }
                break;
            case 2:
                {
                    const validationNumber = parseInt(validationValue, 10);

                    switch (question.class_type) {
                        case 1: {
                            return parseInt(response.setOneResponse, 10) === validationNumber ? validationCondition.message.en : '';
                        }
                            break;
                        case 2: {
                            return parseInt(response.setOneResponse, 10) === validationNumber || parseInt(response.setTwoResponse, 10) === validationNumber
                                ? validationCondition.message.en : '';
                        }
                            break;
                        case 3: {
                            return parseInt(response.setOneResponse, 10) === validationNumber || parseInt(response.setTwoResponse, 10) === validationNumber || parseInt(response.setThreeResponse, 10) === validationNumber
                                ? validationCondition.message.en : '';
                        }
                            break;
                    }
                }
                break;
            case 3:
                {
                    const validationDate = moment(validationValue, "DD-MM-YYYY");
                    const setOneDate = moment(response.setOneResponse);
                    const setTwoDate = moment(response.setTwoResponse);
                    const setThreeDate = moment(response.setThreeResponse);

                    switch (question.class_type) {
                        case 1: {
                            return !response.setOneResponse || setOneDate.isSame(validationDate) ? validationCondition.message.en : '';
                        }
                            break;
                        case 2: {
                            return !response.setOneResponse || !response.setTwoResponse || setOneDate.isSame(validationDate) || setTwoDate.isSame(validationDate)
                                ? validationCondition.message.en : '';
                        }
                            break;
                        case 3: {
                            return !response.setOneResponse || !response.setTwoResponse || !response.setThreeResponse || setOneDate.isSame(validationDate) || setTwoDate.isSame(validationDate) || setThreeDate.isSame(validationDate)
                                ? validationCondition.message.en : '';
                        }
                            break;
                    }
                }
                break;
        }

        return '';
    }

    validateForNotEqualCheck(question: any, validationCondition: any, response: any) {
        const validationValue = validationCondition.value;
        switch (question.input_type) {
            case 1:
            case 4:
            case 5:
                {
                    switch (question.class_type) {
                        case 1: {
                            return response.setOneResponse !== validationValue && response.setOneResponse ? validationCondition.message.en : '';
                        }
                            break;
                        case 2: {
                            return (response.setOneResponse !== validationValue || response.setTwoResponse !== validationValue) && response.setOneResponse && response.setTwoResponse
                                ? validationCondition.message.en : '';
                        }
                            break;
                        case 3: {
                            return (response.setOneResponse !== validationValue || response.setTwoResponse !== validationValue || response.setThreeResponse !== validationValue) && response.setOneResponse && response.setTwoResponse && response.setThreeResponse
                                ? validationCondition.message.en : '';
                        }
                            break;
                    }
                }
                break;
            case 2:
                {
                    const validationNumber = parseInt(validationValue, 10);

                    switch (question.class_type) {
                        case 1: {
                            return parseInt(response.setOneResponse, 10) !== validationNumber ? validationCondition.message.en : '';
                        }
                            break;
                        case 2: {
                            return parseInt(response.setOneResponse, 10) !== validationNumber || parseInt(response.setTwoResponse, 10) !== validationNumber
                                ? validationCondition.message.en : '';
                        }
                            break;
                        case 3: {
                            return parseInt(response.setOneResponse, 10) !== validationNumber || parseInt(response.setTwoResponse, 10) !== validationNumber || parseInt(response.setThreeResponse, 10) !== validationNumber
                                ? validationCondition.message.en : '';
                        }
                            break;
                    }
                }
            case 3:
                {
                    const validationDate = moment(validationValue, "DD-MM-YYYY");
                    const setOneDate = moment(response.setOneResponse);
                    const setTwoDate = moment(response.setTwoResponse);
                    const setThreeDate = moment(response.setThreeResponse);

                    switch (question.class_type) {
                        case 1: {
                            return setOneDate.date !== validationDate.date ? validationCondition.message.en : '';
                        }
                            break;
                        case 2: {
                            return setOneDate.date !== validationDate.date || setTwoDate.date !== validationDate.date
                                ? validationCondition.message.en : '';
                        }
                            break;
                        case 3: {
                            return setOneDate.date !== validationDate.date || setTwoDate.date !== validationDate.date || setThreeDate.date !== validationDate.date
                                ? validationCondition.message.en : '';
                        }
                            break;
                    }
                }
                break;

        }

        return '';
    }

    validateForGreaterThanCheck(question: any, validationCondition: any, response: any) {
        const validationValue = validationCondition.value;
        switch (question.input_type) {
            case 2:
                {
                    switch (question.class_type) {
                        case 1: {
                            if (parseInt(response.setOneResponse, 10) > parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                        case 2: {
                            if (parseInt(response.setOneResponse, 10) > parseInt(validationValue, 10)
                                || parseInt(response.setTwoResponse, 10) > parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                        case 3: {
                            if (parseInt(response.setOneResponse, 10) > parseInt(validationValue, 10)
                                || parseInt(response.setTwoResponse, 10) > parseInt(validationValue, 10)
                                || parseInt(response.setThreeResponse, 10) > parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                    }
                }
                break;
            case 3:
                {
                    const validationDate = moment(validationValue, "DD-MM-YYYY");
                    const setOneDate = moment(response.setOneResponse);
                    const setTwoDate = moment(response.setTwoResponse);
                    const setThreeDate = moment(response.setThreeResponse);

                    switch (question.class_type) {
                        case 1: {
                            return !response.setOneResponse || setOneDate.isAfter(validationDate) ? validationCondition.message.en : '';
                        }
                            break;
                        case 2: {
                            return !response.setOneResponse || !response.setTwoResponse || setOneDate.isAfter(validationDate) || setTwoDate.isAfter(validationDate)
                                ? validationCondition.message.en : '';
                        }
                            break;
                        case 3: {
                            return !response.setOneResponse || !response.setTwoResponse || !response.setThreeResponse || setOneDate.isAfter(validationDate) || setTwoDate.isAfter(validationDate) || setThreeDate.isAfter(validationDate)
                                ? validationCondition.message.en : '';
                        }
                            break;
                    }
                }
                break;
        }

        return '';
    }

    validateForLessThanCheck(question: any, validationCondition: any, response: any) {
        const validationValue = validationCondition.value;
        switch (question.input_type) {
            case 2:
                {
                    switch (question.class_type) {
                        case 1: {
                            if (parseInt(response.setOneResponse, 10) < parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                        case 2: {
                            if (parseInt(response.setOneResponse, 10) < parseInt(validationValue, 10)
                                || parseInt(response.setTwoResponse, 10) < parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                        case 3: {
                            if (parseInt(response.setOneResponse, 10) < parseInt(validationValue, 10)
                                || parseInt(response.setTwoResponse, 10) < parseInt(validationValue, 10)
                                || parseInt(response.setThreeResponse, 10) < parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                    }
                }
                break;
            case 3:
                {
                    const validationDate = moment(validationValue, "DD-MM-YYYY");
                    const setOneDate = moment(response.setOneResponse);
                    const setTwoDate = moment(response.setTwoResponse);
                    const setThreeDate = moment(response.setThreeResponse);

                    switch (question.class_type) {
                        case 1: {
                            return !response.setOneResponse || setOneDate.isBefore(validationDate) ? validationCondition.message.en : '';
                        }
                            break;
                        case 2: {
                            return !response.setOneResponse || !response.setTwoResponse || setOneDate.isBefore(validationDate) || setTwoDate.isBefore(validationDate)
                                ? validationCondition.message.en : '';
                        }
                            break;
                        case 3: {
                            return !response.setOneResponse || !response.setTwoResponse || !response.setThreeResponse || setOneDate.isBefore(validationDate) || setTwoDate.isBefore(validationDate) || setThreeDate.isBefore(validationDate)
                                ? validationCondition.message.en : '';
                        }
                            break;
                    }
                }
                break;
        }

        return '';
    }

    validateForGreaterThanEqualCheck(question: any, validationCondition: any, response: any) {
        const validationValue = validationCondition.value;
        switch (question.input_type) {
            case 2:
                {
                    switch (question.class_type) {
                        case 1: {
                            if (parseInt(response.setOneResponse, 10) >= parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                        case 2: {
                            if (parseInt(response.setOneResponse, 10) >= parseInt(validationValue, 10)
                                || parseInt(response.setTwoResponse, 10) >= parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                        case 3: {
                            if (parseInt(response.setOneResponse, 10) >= parseInt(validationValue, 10)
                                || parseInt(response.setTwoResponse, 10) >= parseInt(validationValue, 10)
                                || parseInt(response.setThreeResponse, 10) >= parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                    }
                }
                break;
            case 3:
                {
                    const validationDate = moment(validationValue, "DD-MM-YYYY");
                    const setOneDate = moment(response.setOneResponse);
                    const setTwoDate = moment(response.setTwoResponse);
                    const setThreeDate = moment(response.setThreeResponse);

                    switch (question.class_type) {
                        case 1: {
                            return !response.setOneResponse || setOneDate.isSameOrAfter(validationDate) ? validationCondition.message.en : '';
                        }
                            break;
                        case 2: {
                            return !response.setOneResponse || !response.setTwoResponse || setOneDate.isSameOrAfter(validationDate) || setTwoDate.isSameOrAfter(validationDate)
                                ? validationCondition.message.en : '';
                        }
                            break;
                        case 3: {
                            return !response.setOneResponse || !response.setTwoResponse || !response.setThreeResponse || setOneDate.isSameOrAfter(validationDate) || setTwoDate.isSameOrAfter(validationDate) || setThreeDate.isSameOrAfter(validationDate)
                                ? validationCondition.message.en : '';
                        }
                            break;
                    }
                }
                break;
        }

        return '';
    }

    validateForLessThanEqualCheck(question: any, validationCondition: any, response: any) {
        const validationValue = validationCondition.value;
        switch (question.input_type) {
            case 2:
                {
                    switch (question.class_type) {
                        case 1: {
                            if (parseInt(response.setOneResponse, 10) <= parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                        case 2: {
                            if (parseInt(response.setOneResponse, 10) <= parseInt(validationValue, 10)
                                || parseInt(response.setTwoResponse, 10) <= parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                        case 3: {
                            if (parseInt(response.setOneResponse, 10) <= parseInt(validationValue, 10)
                                || parseInt(response.setTwoResponse, 10) <= parseInt(validationValue, 10)
                                || parseInt(response.setThreeResponse, 10) <= parseInt(validationValue, 10)) {
                                return validationCondition.message.en;
                            }
                        }
                            break;
                    }
                }
                break;
            case 3:
                {
                    const validationDate = moment(validationValue, "DD-MM-YYYY");
                    const setOneDate = moment(response.setOneResponse);
                    const setTwoDate = moment(response.setTwoResponse);
                    const setThreeDate = moment(response.setThreeResponse);

                    switch (question.class_type) {
                        case 1: {
                            return !response.setOneResponse || setOneDate.isSameOrBefore(validationDate) ? validationCondition.message.en : '';
                        }
                        case 2: {
                            return !response.setOneResponse || !response.setTwoResponse || setOneDate.isSameOrBefore(validationDate) || setTwoDate.isSameOrBefore(validationDate)
                                ? validationCondition.message.en : '';
                        }
                        case 3: {
                            return !response.setOneResponse || !response.setTwoResponse || !response.setThreeResponse || setOneDate.isSameOrBefore(validationDate) || setTwoDate.isSameOrBefore(validationDate) || setThreeDate.isSameOrBefore(validationDate)
                                ? validationCondition.message.en : '';
                        }
                    }
                }
                break;
        }

        return '';
    }

    renderQuestionComments() {
        const elements: any = [];
        if (this.props.question && this.props.question.question_comments && this.props.question.question_comments.length > 0 && (this.props.question.status === QuestionStatus.SubmittedForReview || this.props.question.status === QuestionStatus.AssignToCreator)) {
            this.props.question.question_comments.forEach((comment: any) => {
                const localTime = moment.utc(comment.commented_date).toDate();
                const localTimeFormatted = moment(localTime).format('DD-MM-YYYY hh:mm:ss a');
                elements.push(
                    <Card className={comment.commented_by_role && comment.commented_by_role === 'HQ Admin' ? "commentsBoxRed" : "commentsBoxRegional"}>
                        <CardContent>
                            <div className="card card-default">
                                <div className="card-body">

                                    <div className="addCommentAction alignWrapper">
                                        <div className="alignLeft">
                                            <div className="comment-user">{comment ? `${comment.commented_by_name}(${comment.commented_by_role}) | ${comment.commented_by_email}` : ''}</div>
                                        </div>
                                    </div>

                                    <div className="comment-post">
                                        <span>
                                            {comment ? comment.comment_text : ''}
                                        </span>
                                    </div>
                                    <div className="text-right">
                                        <span className="comment-date"> {comment ? localTimeFormatted : ''}</span>
                                    </div>
                                </div>
                            </div>

                        </CardContent>
                    </Card>
                );
            });
        }

        return elements;
    }

    // handle the click event of question status buttons 
    handleHQAdminQuestionStatus = (event: any, adminQuestionStatus: AdminQuestionStatus) => {
        this.setState({
            adminQuestionStatus,
        })
    }

    // close confirm dialog
    handleCloseConfirmation = (adminQuestionStatus: AdminQuestionStatus) => {
        this.setState({
            adminQuestionStatus,
        })
    }

    // handle yes confim button click event
    handleHQAdminConfimYesButton = (questionId: any) => {
        const inputModel = {
            moduleId: this.props.moduleId,
            questionId,
            pageNumber: this.props.pageNumber,
            clusterId: this.props.clusterIndex
        }

        this.props.approveQuestion(inputModel, this.state.adminQuestionStatus);
        this.handleCloseConfirmation(AdminQuestionStatus.None)
    }

    render() {
        return (
            <div>
                {
                    this.props.question && this.props.question.is_visible &&
                    <div className="questionWrapper" id={this.props.pageNumber + '_' + this.props.clusterIndex + '_' + this.props.questionIndex}>
                        <Grid container={true}>
                            <Grid item={true} xs={1} className="queNo" >
                                <span>{this.props.question.question_number}</span>
                            </Grid>
                            <Grid item={true} xs={6} className="queType" >
                                <div>
                                    {
                                        this.props.userId === 2 && (this.props.question.status === QuestionStatus.SubmittedForReview || this.props.question.status === QuestionStatus.AssignToCreator) &&
                                        <IconButton className="warningIconColor" title={this.props.question.status === QuestionStatus.SubmittedForReview ? 'This question is submitted for review' : 'This question is assigned back to Regional Admins'}> <WarningIcon /></IconButton>
                                    } {this.props.question.title.en}
                                </div>
                                <div>
                                    {
                                        this.renderQuestionByQuestionType()
                                    }
                                </div>

                                {
                                    // Existing code
                                    <div className="showDataBoxWrapper">
                                        {
                                            this.props.question && this.props.question.ram_question_indicator_code && !this.props.isOfflineMode ?

                                                <Typography>
                                                    <Link href="javascript:void(0)" onClick={this.handleRamIntegration.bind(this, this.props.question.ram_question_indicator_code, this.props.countryModuleSurveyMappingId)} className="pageLink showDataLink">
                                                    View RAM data
                                            </Link>
                                                </Typography> : ''
                                        }
                                    </div>
                                    // :
                                    // ''
                                }
                            </Grid>
                            <Grid item={true} xs={5} className="queComments" >
                                {
                                    this.props.question.tooltip &&
                                        this.props.question.tooltip.en &&
                                        this.props.question.tooltip.en !== "<p><br></p>" ?
                                        <div className="commentsWrapper">
                                            <>
                                                <IconButton
                                                    aria-label="Show hint text"> <HelpIcon />
                                                </IconButton>
                                                {
                                                    this.state.collapsed
                                                        ?
                                                        <div className="queCommentsText">
                                                            {ReactHtmlParser(this.props.question.tooltip.en.substr(0, 100))}
                                                            <Typography>
                                                                <Link href="javascript:void(0)" onClick={this.toggleExpand.bind(this, false)} className="pageLink">[ Expand ]</Link>
                                                            </Typography>
                                                        </div>
                                                        :
                                                        <div className="queCommentsText">
                                                            {ReactHtmlParser(this.props.question.tooltip.en)}
                                                            <Typography>
                                                                <Link href="javascript:void(0)" onClick={this.toggleExpand.bind(this, true)} className="pageLink">[ Collapse ]</Link>
                                                            </Typography>
                                                        </div>
                                                }

                                            </>

                                        </div>
                                        :
                                        ''
                                }
                                {
                                    !this.props.isOfflineMode ?
                                        <div className="commentsBoxWrapper">
                                            {
                                                this.props.userId === 1 && (this.props.question.status === QuestionStatus.SubmittedForReview || this.props.question.status === QuestionStatus.AssignToCreator) &&
                                                <div className="reviewButtons">
                                                    <Button type="button" disabled={this.props.question.status === QuestionStatus.AssignToCreator ? true : false} className="btn-blue" variant="outlined" onClick={(event: any) => this.handleHQAdminQuestionStatus(event, AdminQuestionStatus.Approve)} value="Approve">Approve</Button>
                                                    <Button type="button" disabled={this.props.question.status === QuestionStatus.AssignToCreator ? true : false} className="btn-blue" variant="outlined" onClick={(event: any) => this.handleHQAdminQuestionStatus(event, AdminQuestionStatus.Reject)} value="Reject">{QuestionStatus.Reject}</Button>
                                                    <Button type="button" disabled={this.props.question.status === QuestionStatus.AssignToCreator ? true : false} className="btn-blue" variant="outlined" onClick={(event: any) => this.handleHQAdminQuestionStatus(event, AdminQuestionStatus.AssignToCreator)} value="AssignToCreator">{QuestionStatus.AssignToCreator}</Button>
                                                </div>
                                            }
                                            <div className="commentsBadge alignWrapper">
                                                {
                                                    (this.props.question.status === QuestionStatus.SubmittedForReview || this.props.question.status === QuestionStatus.AssignToCreator) &&
                                                    <>
                                                        <div className="alignLeft">
                                                            {
                                                                (!this.props.question || !this.props.question.question_comments || this.props.question.question_comments.length === 0) ?
                                                                    <b className="textCapital">No Comments Yet...</b>
                                                                    :
                                                                    <b className="textCapital">{`Comments (${this.props.question.question_comments_count})`}</b>
                                                            }
                                                        </div>
                                                        <div className="grow" />
                                                        <div className="alignRight">
                                                            {
                                                                this.props.question && this.props.question.question_comments && this.props.question.question_comments.length > 0 ?
                                                                    <Typography>
                                                                        <Link href="javascript:void(0)" className="pageLink" onClick={() => this.handleShowAllComments(this.props.question.question_id)} >
                                                                            Show All Comments
                                                            </Link>
                                                                    </Typography>
                                                                    : ''
                                                            }
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    (this.props.question.status === QuestionStatus.SubmittedForReview || this.props.question.status === QuestionStatus.AssignToCreator) && this.state.showCommentsDialog &&
                                                    <ReviewCommentComponent
                                                        showCommentsDialog={this.state.showCommentsDialog}
                                                        onDialogClose={this.handleShowAllCommentsClose}
                                                        questionId={this.props.question.question_id}
                                                        comments={this.state.comments}
                                                    />
                                                }
                                                {
                                                    this.state.showRamIntegrationDialog &&
                                                    <RamIntegrationComponent
                                                        showRamIntegrationDialog={this.state.showRamIntegrationDialog}
                                                        onDialogClose={this.handleRamIntegrationClose}
                                                        ramIntegrationData={this.state.ramIntegrationData}
                                                    />
                                                }
                                            </div>
                                            {
                                                this.props.question && this.props.question.question_comments && this.props.question.question_comments.length > 0
                                                    ?
                                                    this.renderQuestionComments()
                                                    :
                                                    ''
                                            }
                                            {
                                                this.state.addCommentDivVisible && (this.props.question.status === QuestionStatus.SubmittedForReview || this.props.question.status === QuestionStatus.AssignToCreator) ?
                                                    <div className="addComment">
                                                        <FormControl margin="normal" required={false} fullWidth={true} >
                                                            <InputLabel htmlFor="commentDescription">Comment Description</InputLabel>
                                                            <Input id="commentDescription" name="commentDescription"
                                                                multiline={true}
                                                                autoFocus={false}
                                                                value={this.state.addCommentDescription}
                                                                onChange={this.handleCommentDescriptionChange}
                                                            />
                                                        </FormControl>
                                                        <div className="addCommentAction alignWrapper">
                                                            <div className="alignLeft">
                                                                <Link href="javascript:void(0)" onClick={this.toggleAddCommentDiv.bind(this, false)} className="linkRed">
                                                                    Cancel
                                                        </Link>
                                                            </div>
                                                            <div className="grow" />
                                                            <div className="alignRight">
                                                                <Button type="button" className="btn-blue-primary" onClick={(event: any) => this.addReviewQuestionComment(event)} variant="outlined" size="medium">
                                                                    Add Comment <ChevronRightIcon className="ChevronRightIcon" />
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    :
                                                    ''
                                            }
                                            <div>
                                                {
                                                    !this.state.addCommentDivVisible && (this.props.question.status === QuestionStatus.SubmittedForReview || this.props.question.status === QuestionStatus.AssignToCreator) ?
                                                        <Typography>
                                                            <Link href="javascript:void(0)" onClick={this.toggleAddCommentDiv.bind(this, true)} className="pageLink">
                                                                + Add Comment
                                                        </Link>
                                                        </Typography>
                                                        :
                                                        ''
                                                }
                                            </div>
                                        </div>
                                        : ''
                                }
                            </Grid>
                            <Grid item={true} xs={12}>
                                {
                                    this.state.validationMessages && this.state.validationMessages.length ?
                                        (<div>
                                            <div className="warningMessage">
                                                <span className="warningMessageIcon">
                                                    <WarningIcon />
                                                </span>
                                                {this.state.validationMessages[0]}
                                            </div>
                                        </div>
                                        ) : ''
                                }
                            </Grid>
                        </Grid>
                        <ConfirmationComponent
                            handleDialogSubmit={() => this.handleHQAdminConfimYesButton(this.props.question.question_id)}
                            message={this.state.adminQuestionStatus === AdminQuestionStatus.Approve ? APPROVED_QUESTION_CONFIRAMATION :
                                this.state.adminQuestionStatus === AdminQuestionStatus.Reject ? REJECT_QUESTION_CONFIRAMATION : this.state.adminQuestionStatus === AdminQuestionStatus.AssignToCreator ? ASSIGN_CREATOR_QUESTION_CONFIRAMATION : ''}
                            open={this.state.adminQuestionStatus === AdminQuestionStatus.Approve || this.state.adminQuestionStatus === AdminQuestionStatus.Reject || this.state.adminQuestionStatus === AdminQuestionStatus.AssignToCreator}
                            onCloseConfirmation={() => this.handleCloseConfirmation(AdminQuestionStatus.None)}
                        />
                    </div>
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/reviewquetions/QuestionReviewComponent.tsx